module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v("n the great hall of the king’s castle at Winchester, Lady Anne Delasaine delicately tore a piece of venison from the portion on the platter before her and held it out to the hound. His flanks aquiver with anticipation, the huge brown beast reached to take the tasty morsel from her fingers. He wolfed it down, then seemed to grin as he waited for more. She smiled in return and pulled off another piece.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The other courtiers supping there could be forgiven for assuming Lady Anne found assuaging the dog’s appetite an amusing diversion that took all her feminine attention. In fact, however, she was listening to the conversation of her two dark-haired half brothers seated near her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“I tell you, it is only a matter of time,” the eldest, Damon, said firmly, his voice conspiratorially low. His brown eyes glittered beneath his heavy brows, which looked as if they had been parted by the sharp ridge of his prominent nose. “Henry must realize that he ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("would be wise to listen to Eleanor and her kinsmen. We should be in their counsel.”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As Anne fed the hound another scrap, she kept her dismay and disgust at Damon’s arrogant tone and vaulting ambition from her face. After all, he was not discussing a minor noble family—he was speaking of the king and queen of England.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Young Henry had recently wed Eleanor of France, a political match that had already created more tension than it relieved. Anne and her siblings were distantly—very distantly—related to Eleanor through their late father, and Damon had lost no time using that tenuous connection to full advantage. He had insinuated his way into Eleanor’s entourage and Henry’s court. Not only that, he had managed to include the rest of his family in that entourage, albeit for his own purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“If they don’t see that, we’ll "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("make")]), _vm._v(" them,” the younger and brawnier Benedict muttered. Holding his knife in his thick fingers, he raised it and split the apple before him as if he were a headsman wielding an ax. “Everyone knows Englishmen are all fools.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“This isn’t the place to make such a remark,” Damon growled. “In case you haven’t noticed, the hall is full of Normans more loyal to Henry than the king of France.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I don’t care what they think, and tomorrow on the tournament field, they’ll find out we are the better men.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Shut your mouth about the English,”")]), _vm._v(" Damon or")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("dered, effectively commanding his brother’s silence and his obedience as he had since the death of their father three years ago.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Benedict, as usual, retreated into sulky silence and the matter was apparently closed. Her attention still supposedly on the dog, Anne did not have to see Damon’s face to imagine his arrogant smirk. She had seen it often enough when he chastised his siblings, for since their father’s death Damon had every right to rule the family, just as Rannulf Delasaine had, and with just as heavy a hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Well, wait until I get a chance with my new tournament sword,” Benedict mumbled after a moment. “Blunted it may be, but I’ll have bashed a few English heads before I’m through.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You’d better not ruin it on too many helmets. I’m not paying for a blacksmith to fix it,” Damon replied. “You would have been smarter to get something less costly if that was your plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Who was it had to have a new shield, eh, when there was nothing wrong with the old one?” Benedict charged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Anne stopped listening as they began to quarrel about the new and expensive items they had purchased before traveling to Winchester, for this subject could have little bearing on her life at court and her possible future, which Damon would never discuss directly with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She clenched her jaw, knowing well his reason: she was but a woman, so she must do as he commanded.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Next year at this time, she might already be married off to some noble of his choosing, and with child. It would be a match made solely to increase Damon’s power and influence, and it would be the fulfillment of what he considered the only thing she was good for. She had been unhappily awaiting that fate ever since she had reached her twelfth year and Damon realized his skinny, gawky half sister with the big eyes was going to be a beauty after all. Ever since, he had guarded her as fiercely as their other valuable possessions, and treated her exactly the same way—as if she had no will or mind or heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With a weary sigh she let her gaze rove over the huge hall magnificently decorated to commemorate Saint Edmond the Confessor, whom King Henry had made his patron saint. Henry always celebrated the saint’s special day, October 13, with a feast and merrymaking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The tables were set with fine white linens and silver plates. Torches burned in sconces in the walls, and the flickering flames of beeswax candles added to the illumination. Bright banners hung suspended overhead, and musicians in the gallery played softly, the music nearly drowned out by the conversation and laughter of Henry’s guests.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("She surveyed the well-dressed ladies in their fine gowns and headdresses, the smartly attired men in their satins and velvets and furs, and the richly colored tapestries. She set herself to enjoying the music of the ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("minstrels and the exceptional food prepared in a variety of new and startling ways.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Across the hall, a boisterous group of young knights, merry and probably more than half in their cups, were clearly having a marvelous time eating the king’s food, drinking the king’s wine and enjoying the attention of young ladies who seemed utterly captivated by them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That wasn’t so surprising, for they were a good-looking bunch, well built and attractive. The two with curling black hair were the best-looking. They were probably brothers, judging by their coloring and their similar noses and mouths. The other three, who shared brown hair in shades varying from light brown to a rich chestnut, strong jaws and lean features, were also probably related. They were as broad shouldered and muscular as the other two, but not so conventionally handsome. The tallest of these looked to be the oldest, for there was something aloof and imposing in his manner that the others lacked. The youngest of the group appeared little older than her younger brother, Piers, and he was fourteen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("They all seemed very well pleased with themselves. No doubt that went hand in hand with being the spoiled sons of rich men.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("A surge of bitterness welled up inside her breast. What would they know of deprivation or harsh punishments? Of being forced to fast, or beaten with a strip of willow for some minor infraction? Probably ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("nothing, and neither would those silly, giggling girls so obviously trying to win their masculine attention.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The envy and bitterness slowly slipped away as she fed the hound again. Those giggling girls would surely be sold off in marriage just as she would be. Could she fault them, then, for having a little harmless flirtation when they had the chance? Wouldn’t she, if she wasn’t constantly watched over by her half brothers?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If she thought she could get away with it, she would probably be the most high-spirited one of all, knowing that she had but a short time to indulge in such levity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Have you gone deaf, Anne?” Damon demanded, his voice a harsh snarl in her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She looked up to find him glaring at her, as he so often did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She had long ago learned the best way to deal with her aggressive half siblings was to be as placid as possible—and pummel her pillow later. “What is it, Damon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“There is Lord Renfrew.” Damon nodded at a stout, middle-aged man dressed in a long tunic of brilliant scarlet velvet that made him look like a fat red worm. “He’s very rich, and his third wife died last Michaelmas. If he looks at you, smile. If he asks you to join him in the dancing, you will dance. Understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes, Damon, I understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His eyes narrowed as if he wasn’t sure whether he believed her or not.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("In truth, she had no intention of disobeying. If Lord ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Renfrew looked at her, she would make a very cold, very unpleasant smile that would imply she would sooner eat dung than talk to him. If he asked her to dance, she would accept, and then she would step on his toes and ignore whatever he said. On the other hand, it might be better to avoid that situation entirely, in case the nobleman complained of her to Damon.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She rose and put her hand to her brow. “Unfortunately, Damon, I have a pain in my head. I think I had best retire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Benedict joined Damon in his glowering.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You do want me at my best, do you not?” she asked. “I will not be if I remain. Besides, don’t you think a little air of mystery a good idea? I have appeared, potential suitors have seen me, so let me leave them wondering about me. You should stay here, of course. You may have another chance to remind Queen Eleanor that we are related to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She held back a relieved sigh as, after a moment’s reflection, Damon nodded his permission. “Go straight to your chamber,” he commanded with a scowl. “Don’t talk to anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Not even Lord Renfrew?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon gave her a disgruntled look. “If he addresses you, you may speak to him. Nobody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was on the tip of her tongue to query him about the king, but she decided she would be wiser to get away before Damon and Benedict decided to accompany her, a prospect about as delightful as having a guard of sly and surly wolves.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("After swiftly leaving the hall, she slowed her pace to stroll along the corridor lit by torches. Their smoke drifted out through long, narrow windows open to the air. She wrapped her arms about herself and shivered, in spite of the heavy velvet brocade gown she wore, for the October night was chill. She would be glad to get to her chamber, which would be warmed by a brazier full of glowing coals. There she could get into bed and let herself remember all that she had seen before she drifted off to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She would think of the beautiful gowns and rich fabrics. She would imagine that she was one of that giggly gaggle of girls, except that in her waking dream she would bandy such clever words with the young men, they would be agog.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She wondered who that particular group of young men were and where they came from. Were they English or French or some other nationality? Were they sons of great lords or minor nobility? Were any of them married? What of the one who seemed more mature than the others?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She heard a sound behind her and halted, turning to see what it was. A mouse, perhaps, or the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A man stood in the shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She stiffened, then reminded herself she was in the king’s castle, and there were many soldiers on guard. She had but to scream, and she would be heard. As her half brothers knew, she could scream very loudly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The man stepped out of the shadows into the flick")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("ering light of the torches. It was the eldest of that merry group in the hall, the one with chestnut-brown hair. The aloof, impressive one.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Standing up, he seemed even more splendid than when he had been sitting down, with long, lean legs she had no business staring at. His plain black tunic reached to mid-thigh and stretched across broad shoulders. The pristine white shirt beneath made his tanned face seem even more masculine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Most intriguing and unusual, though, were his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("They were light-gray and rimmed with black, so startling a contrast to his dark complexion, they seemed to glow in the torchlight. His nose was particularly fine, and his lips were full and made her wonder what they would be like to kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bold, wanton thought!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still, those others in the hall could not really com pare, not now. The curly-haired young men could be cherubs, while this man was an archangel—Saint Michael, perhaps. God’s warrior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He ambled closer and her heart began to pound, the throbbing loud in her ears. This was a situation entirely new to her, and entirely exciting. But this meeting was really most improper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Yet her half brothers were back there in the hall, no doubt quarreling about something. Piers was in his room, sulking because Damon had made him stay be hind as punishment for not polishing his armor well ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("enough. She was, in the only sense she ever was, free, if only for a little while.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("An unfamiliar excitement, potent and dangerous, skittered through her body as she envisioned a clandestine rendezvous with this man. Her mind reeled as pictures of what might happen in a secluded corridor flashed unbidden into her imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("An embrace. A passionate kiss. Moans. Sighs. Her leg bared as his strong, lean hand lifted her skirt…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She flushed, hot with shame at her own vivid imaginings, while he continued to regard her steadily, not with arrogance or lust, but as if he could not look away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("No one had ever looked at her like that, and no gaze had ever made her feel so warm and yet so full of dread at the same time. It was not fear that he might hurt her, though, a fear she already knew too well. She could not yet name the powerful new feeling surging through her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Who are you?” she demanded, trying to sound calmer than she felt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I want to ask you the same question. I beg you to tell me the name of the most beautiful woman at court,” the stranger said, his voice soft and deep and very different from her siblings’ harsh tones. Damon and Benedict sounded like bears. This man sounded as she imagined a majestic stag would, if stags could speak.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("As his gaze seemed to intensify with attentive cu")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("riosity, Anne realized what she felt: desire. It spread over her like the rays of the sun when the clouds part.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her mind urged caution. No matter how thrilling she found him, or how outrageously flattered she was by his attention, she was a lady, not some simple peasant girl, or even one of those flighty creatures in the king’s hall. This young man had no business following her or speaking to her, and he had to know that as well as she. If he thought she would not mind, or even welcomed his advances, what did that say of his opinion of her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Maybe she should flee—except that would be the action of a coward, and she was not a coward. Instead Anne straightened her shoulders and haughtily said, “Who are you, to follow me in this insolent manner and ask who I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God,")]), _vm._v(" Reece thought as he felt his face warm with a blush. He wished he had stayed in the hall and ignored his impetuous, uncharacteristic impulse to follow the blond beauty. He should leave, but to back away now would be fleeing like a coward. While he was certainly shy around women, he was no coward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Nevertheless he knew full well he didn’t have the charm, the eloquence or the looks of his friends. He had always been content to wait patiently nearby, half-afraid to open his mouth in case he sounded like a fool.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Until tonight, when he had spotted the tranquil, ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("golden-haired woman across the hall wearing a green gown of shining samite that fairly sparkled in the candlelight. She had to be unmarried, for her long, golden hair was uncovered and done in two braids, the ends encased in bronze. Her hair had glowed in the light like a halo, and she had seemed as serenely different from the rest of the young women at the court as an angel would. So he had foolishly decided to follow her from the hall.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The die was cast, he decided, and he must see it through.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But please, God,")]), _vm._v(" he silently and fervently prayed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do not let her see me blush like a lad!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Forgive me, lady,” he said with a contrite bow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I meant no insult.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("To his surprise, she didn’t immediately turn on her heel and march away. Instead, her full lips turned up in a little smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was like thinking your lance was broken and discovering instead that it was whole.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Although you seem an impertinent fellow,” she said, “I was not insulted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then will you tell me your name, despite my impertinence?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her shapely brow rose in query. “You wish to know my name and nothing more?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("In truth, he wanted to know everything about her, but he had achieved much already and did not dare to ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("hope for more. “Perhaps that should be all, lest I discover you are wed or promised to another.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her brows lowered as she studied him, and he cringed inwardly. Obviously, that had not been a wise thing to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I am not, but this is hardly the time or place to make introductions, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He moved closer, almost as if pulled to her by an invisible thread. Maybe there was such a thread, for that might explain the tightening sensation he felt in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As if by divine inspiration, he remembered something he had heard Blaidd Morgan say to a woman once. Blaidd attracted women like blossoms did a bee. “Please, won’t you take pity on me and tell me your name? Otherwise, I may risk injury in the tournament tomorrow, being overtired because I could not sleep for wondering.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her brows, a shade darker than her hair, rose yet farther, and her green eyes that already sparkled like emeralds in a rich man’s ring seemed to glitter even more, and—he was very pleased to believe—with merriment. “So if I do not tell you my name, and you happen to be injured on the morrow, it will be my fault?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("To his dismay, her glittering gaze faltered, and a frown clouded her visage. “I do not want such a responsibility. I assure you, sir knight, I already have enough burdens to bear.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The note of sadness in her voice touched his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Forgive me, my lady, if I add to your distress in any way. I do not seek to add to the troubles you may have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her beautiful eyes widened, as if she was taken aback by his response. “It is a rare man who cares for a stranger’s woes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece flushed again, for her tone was full of both wonder and praise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Then that gloriously merry glimmer seemed to light her from within again. “Besides, you have not told me your name, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She straightened her shoulders and issued a charming challenge. “If you first tell me your name, humble petitioner, I shall tell you mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His heart started to pound as it did before a lance charge and new hope thundered into life with it. She must not think him a complete fool after all. “My name is Sir—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Anne!”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The man’s bellowing voice echoed off the walls of the corridor and the unknown beauty tensed as if she had just been caught perpetrating a serious crime.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("God save him, he had not considered how it would look to others if they were seen or found together. He had been too intent upon learning who she was. Be fore he could speak, she did.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Go!” She ordered him as if he were a foot soldier. ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("She pointed down the corridor to the door at the opposite end. “Leave me to deal with Damon.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Who, in the name of the saints, was Damon, and what was he to her? Brother? Cousin? Betrothed?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Not the latter, he most fervently hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Whoever he was, as the dark-haired man came charging toward them, another dark-haired, bigger man following right behind, it was obvious he could not leave this fascinating young woman to deal with them alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If there was fault here, it was not hers. She had not enticed him or led him there, and he would certainly make that very clear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As the two men bore down upon them, he recognized them as the men who had been sitting beside her in the king’s hall. Because she had been paying no heed to them, and she was fair while they were dark, he had assumed they were not relations or had any claim upon her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Obviously he was wrong, and if he had not been distracted by Blaidd right before she left the hall, he might have seen her speak to them. Unfortunately, Blaidd had just chastised him for staring, then started to tease him. Reece had turned away to tell his Welsh friend that Blaidd had quite the history of being distracted by women himself, so he should keep his mouth shut. If she had talked to these fellows, he had missed it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("The woman—Anne, he now knew—shoved him in ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("a way no person ever had. “You may leave me to deal with them, sir knight.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I will not,” he said firmly. “The impropriety is mine, and mine alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Clearly enraged, the two men came to a panting halt in front of him, their wine-soaked breath disgusting him. Their extreme reaction to a minor impropriety was no doubt fueled by wine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He took the offensive as they tried to catch their breath. “Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“We’re her brothers,” the biggest one growled, his beefy hands bunching into fists. “Who the devil are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I know who he is,” the taller one declared as his lip curled in a sneer. “It’s that bastard’s son. This lout accosting Anne is Reece Fitzroy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A jolt of anger shot through Reece, even as the big lout’s eyes widened and fear bloomed in his eyes. So, he had heard of Reece Fitzroy, or if not him, his father, the man reputed to be the finest trainer of knights in England, and who was indeed a bastard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sir")]), _vm._v(" Reece Fitzroy,” he corrected. He made no effort to keep the scorn from his voice. “To whom have I the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("honor")]), _vm._v(" of speaking?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The tall one drew himself up. “I am Sir Damon Delasaine of Montbleu, this is my brother Benedict and this lady you are bothering is my sister.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Reece felt like a bellows with a slow leak. He had heard of the notorious Delasaines. They would be the ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("first on a list of all the families in the world a man of honorable ambition should avoid. He could hardly believe that this beautiful, spirited woman, so different from any woman he had ever met, was their sister.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Half")]), _vm._v(" sister,” Anne declared, as if determined to have that difference noted at once. She then addressed Damon Delasaine. “He was not bothering me, Damon. We were merely talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Shut up and go, Anne,” he snarled in response, “before we decide to let you share the beating he has earned.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Another jolt of anger, mixed with indignation and scorn, energized Reece. He stepped forward, the action alone—and perhaps his fierce expression—forcing Damon back. “I have heard of the Delasaines, and all I have heard is obviously true,” he growled. “You are a base coward, for only a coward would strike a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As Damon stared with glowering disbelief, Reece turned to Anne. “Thank you, my lady, for defending me, but I will fight my own battles. Go, as he says, and leave me to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes, go,” Benedict snarled, pushing her roughly away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At that sight, Reece’s self-control snapped. He grabbed Benedict’s arm and yanked him back so hard, he nearly pulled the lout’s arm from its socket. “Let her alone, or by God, you’ll regret it!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Benedict stumbled as Reece let him go, but he ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("quickly recovered, and his eyes gleamed with malice and glee, the look of a man who enjoyed brawling, or beating up women. “Think so?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece nodded. “Oh, believe me, you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Benedict held out his arms and gestured for him to approach. “Come on and try it then, cur.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Reece, behind you!” Anne screeched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Before he could turn, Reece felt an unexpected, sharp pain in his side as Damon’s dagger slid along his rib. He fell to his knees and Benedict’s heavy fist struck his face as Anne let loose with a bloodcurdling scream.")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0537229e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warriorsladya_ch01.vue
// module id = 75
// module chunks = 0